import { makeStyles } from '@material-ui/core/styles';

export const useArrivedIncompleteStyles = makeStyles(() => ({
  container: {
    borderTop: (props) => (props.mobile ? '' : '1px solid #6A148E'),
    backgroundColor: (props) => (props.mobile ? '' : '#F1F1F1'),
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
    width: '100%',
    padding: (props) => (props.mobile ? '' : '30px 70px'),
  },
  sendButton: {
    margin: '0 auto',
    textAlign: 'center',
  },
  radioButton: {
    '& span': {
      fontSize: 16,
    },
  },
  titleRadio: {
    color: '#464646',
    fontSize: '16px',
    marginBottom: 15,
    marginTop: (props) => (props.mobile ? 15 : null),
    textAlign: (props) => (props.mobile ? 'center' : ''),
  },
}));
